module.exports = __webpack_public_path__ + "static/media/homepage.0be4a1e3.png";